document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('[data-faq-question]');

  questions.forEach(question => {
    question.addEventListener('click', () => {
      const currentAnswer = question.nextElementSibling;

      // Close all other answers instantly to avoid layout shift during scroll
      document.querySelectorAll('[data-faq-answer]').forEach(answer => {
        if (answer !== currentAnswer) {
          answer.style.transition = 'none';
          answer.offsetHeight; // force reflow so transition:none is committed
          answer.style.maxHeight = null;
          answer.classList.remove('is-open');
          answer.previousElementSibling?.classList.remove('is-active');
          requestAnimationFrame(() => { answer.style.transition = ''; });
        }
      });

      // Toggle current
      if (currentAnswer.classList.contains('is-open')) {
        currentAnswer.style.maxHeight = null;
        currentAnswer.classList.remove('is-open');
        question.classList.remove('is-active');
      } else {
        currentAnswer.classList.add('is-open');
        currentAnswer.style.maxHeight = currentAnswer.scrollHeight + 'px';
        question.classList.add('is-active');
        setTimeout(() => {
          var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
          var top = question.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 50);
      }
    });
  });
});